module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-wrapper"
  }, [_c('nav', {
    staticClass: "navbar navbar-custom navbar-fixed-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "login-link",
    on: {
      "click": function($event) {
        _vm.$session.showLogin = true
      }
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 offset-2"
  }, [_c('h1', {
    staticClass: "brand-heading"
  }, [_vm._v("Test Stand Portal")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-circle page-scroll",
    attrs: {
      "href": "#about"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down animated"
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container content-section text-center",
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 offset-2"
  }, [_c('h2', [_vm._v("Powered by HIGHLIGHT Industries")]), _vm._v(" "), _c('p', [_vm._v("Highlight was founded in 1981 with a mission to provide the highest value highest quality and highest technology products to our customers. Highlight is the world leader in equipment for testing stretch film. In addition Highlight provides the technology and equipment to evaluate the overall equipment and film effectiveness to increase production, reduce costs and ensure that products arrives undamaged. The HiLIFE System continues our commitment to provide the highest quality, highest value, highest technology solutions to the industry.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticStyle: {
      "background-color": "rgba(100, 100, 100, 1)",
      "color": "#fff",
      "margin-top": "50px"
    }
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('p', [_vm._v("Copyright © 2017 Highlight Industries")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cccdbdc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Landing/Landing.vue
// module id = 734
// module chunks = 8